
export function randomId(len = 15) {
  return btoa(btoa(Math.random().toString(32).substr(2) + Date.now().toString(32))).slice(0, len);
}


export function dynamicSort(key, sortOrder = 1) {
  return function (a,b) {
    if (!a[key] || !b[key]) {
      return -1;
    }
  
    if(sortOrder == -1){
      return b[key].localeCompare(a[key]);
    }else{
      return a[key].localeCompare(b[key]);
    }        
  };
}

export function dynamicSortNumber(key, sortOrder = 1) {
  return function (a,b) {
    if (!a[key] || !b[key]) {
      return -1;
    }
  
    if(sortOrder == -1){
      return b[key] - a[key];
    }else{
      return a[key] - b[key];
    }        
  };
}

export function dynamicSortDate(key, sortOrder = 1) {
  return function (a,b) {
    if(sortOrder == -1){
      return new Date(a[key]).valueOf() - new Date(b[key]).valueOf();
    } else {
      return new Date(b[key]).valueOf() - new Date(a[key]).valueOf();
    }        
  };
}

export function sortCompare( aRow, bRow, key, sortDesc, formatter, compareOptions, compareLocale) {
  if (!aRow[key]) {
    return 1;
  }
  return aRow[key].localeCompare(bRow[key], compareLocale, compareOptions);
}

export function browser() {
  // Opera 8.0+
  // eslint-disable-next-line
  var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;

  // Firefox 1.0+
  var isFirefox = typeof InstallTrigger !== "undefined" || navigator.userAgent.toLowerCase().indexOf("firefox") > -1;

  // Safari 3.0+ "[object HTMLElementConstructor]" 
  var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) {
    return p.toString() === "[object SafariRemoteNotification]";
    // eslint-disable-next-line
  })(!window["safari"] || safari.pushNotification);

  // Internet Explorer 6-11
  var isIE = /*@cc_on!@*/ false || !!document.documentMode;

  // Edge 20+
  var isEdge = !isIE && !!window.StyleMedia;

  // Chrome 1+
  var isChrome = navigator.userAgent.toLowerCase().indexOf("chrome") > -1;

  // Blink engine detection
  var isBlink = (isChrome || isOpera) && !!window.CSS;

  return isOpera ? "Opera" :
    isFirefox ? "Firefox" :
      isSafari ? "Safari" :
        isChrome ? "Chrome" :
          isIE ? "IE" :
            isEdge ? "Edge" :
              "Don't know";
}

function triggerDownload (imgURI, fileName) {
  let evt = new MouseEvent("click", {
    view: window,
    bubbles: false,
    cancelable: true
  });
  let a = document.createElement("a");
  a.setAttribute("download", fileName);
  a.setAttribute("href", imgURI);
  a.setAttribute("target", "_blank");
  a.dispatchEvent(evt);
}

export function downloadSvg(svg, fileName) {
  // svg = document.getElementById("svg99");
  let copy = svg.cloneNode(true);
  // copyStylesInline(copy, svg);
  let canvas = document.createElement("canvas");
  let bbox = {
    width: 700,
    height: 989
  };
  try {
    bbox = svg.getBBox();
  } catch (error) {
    // never mind
  }
  
  let width = bbox.width * 3;
  let height = bbox.height * 3;
  canvas.width = width;
  canvas.height = height;
  let ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, width, height);
  let data = new XMLSerializer().serializeToString(copy);
  data = data.replace("viewBox=\"0 0 700 989\"", `width='${width}' height='${height}' transform='scale(2.8)translate(${width / 3.08},${height / 3.08})'`);
  let DOMURL = window.URL || window.webkitURL || window;
  let img = new Image();
  let svgBlob = new Blob([data], {type: "image/svg+xml;charset=utf-8"});
  let url = DOMURL.createObjectURL(svgBlob);
  img.onload = function () {
    ctx.drawImage(img, 0, 0);
    if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob)
    {
      let blob = canvas.msToBlob();         
      navigator.msSaveOrOpenBlob(blob, fileName);
    } 
    else {
      let imgURI = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      triggerDownload(imgURI, fileName);
    }
    DOMURL.revokeObjectURL(url);
    document.removeChild(canvas);
  };
  img.setAttribute("src", url);
}

export function makeDraggableSvg(svg) {

  let selectedElement, offset;

  svg.addEventListener("mousedown", startDrag);
  svg.addEventListener("mousemove", drag);
  svg.addEventListener("mouseup", endDrag);
  svg.addEventListener("mouseleave", endDrag);
  
  function startDrag(evt) {
    evt.preventDefault();
    if (evt.target.classList.contains("draggable")) {
      selectedElement = evt.target;
      offset = getMousePosition(evt);
      offset.x -= parseFloat(selectedElement.getAttributeNS(null, "x"));
      offset.y -= parseFloat(selectedElement.getAttributeNS(null, "y"));
    }
    
  }
  

  function drag(evt) {
    if (selectedElement) {
      evt.preventDefault();
      let coord = getMousePosition(evt);
      selectedElement.setAttributeNS(null, "x", coord.x - offset.x);
      selectedElement.setAttributeNS(null, "y", coord.y - offset.y);
    }
  }


  function endDrag(evt) {
    selectedElement = null;
  }

  function getMousePosition(evt) {
    var CTM = svg.getScreenCTM();
    return {
      x: (evt.clientX - CTM.e) / CTM.a,
      y: (evt.clientY - CTM.f) / CTM.d
    };
  }



}

export function capitalCase(string) {
  return string
    .split(/(?=[A-Z])/)
    .map(x => x.charAt(0).toUpperCase() + x.slice(1))
    .join(" ");
}
